module.exports = __webpack_public_path__ + "img/img70.a9eac2ac.png";